import { GET_GROUP } from './mutation-types';

export default {
  [GET_GROUP](state, data) {
    state.groups = data.groups;
    state.count = data.count;
    state.lastFilter = data.lastFilter;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/group/mutations.js